
import { Nav } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.css";


const Login = () => {

  return (
    <Nav.Item>
    <Nav.Link href="/login">
      Login
    </Nav.Link>
  </Nav.Item>
  )
}

export default Login